
<template>

  <div id="modalPopupBox" class="modalPopup">
    <div class="modal-popup-content">
      <div class="modal-popup-header">
        <span class="modal_close" v-on:click="closeModal">×</span>
        <h2>{{modalData.title}}</h2>
      </div>
      <div class="modal-popup-main">
        <span v-html="modalData.textAsHTML">
        </span>
      </div>
    </div>
  </div>

</template>


<script>

  /* 

    The format of the modalData
    ---------------------------
    {
      isModalShown: true, 
      modalData: {
        textAsHTML: ..., // this gets used by default, if this is undefined, the normal text will get used.
        type: 'information', // 'warning'/ 'critical'
        // what about buttons: OK, OKCancel, YesNo etc. and return values
        title: 'About'
      }
    }
  
   */

  import Vue from 'vue';

  export default {

    name: 'Modal',
    props: ['modalData'],
    data: () => {
      return {
        
      }
    },
    mounted() {
     // console.log('I am mounted!')

     // This is an event listener for when the user clicks next to the popup.
     // This send sends a signal to not show the popup anymore.
     window.onclick = function(event) {
          let modalPopupBox = document.getElementById('modalPopupBox');
          if (event.target == modalPopupBox) {
            // console.log('Command send to close help.')
            Vue.prototype.$eventHub.$emit("showModal", {isModalShown: false});
          }
        }
    
    },

    methods: {

      // The method below is called when the user clicks the 'x' in the popup.
      // See the v-on:click directive
      closeModal(){
        Vue.prototype.$eventHub.$emit("showModal", {isModalShown: false});
      }
    }
  }

</script>


<style scoped>

/* Scrollbar */

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* Popup Box */
  
  #modalPopupBox {
    z-index: 9999999;
  }

  /* mPopup box style */
  .modalPopup {
    position: fixed;
    z-index: 1;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
  }

  .modal-popup-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    width: 500px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  .modal-popup-header {
    padding: 2px 16px;
    background-color: #51A7DD;
    color: white;
  }

  .modal-popup-main {
    /* This is the part of the pop-up underneath the pop-up header */

    padding: 20px 16px;
    overflow:auto;

  }

  .modal-footer {
    padding: 2px 16px;
    background-color: #999999;
    color: #ffffff;
    font-family: monospace;
    font-size: 12px;
  }

    /* close button style */
  .modal_close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  .modal_close:hover, .modal_close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  
</style>